import type { ColumnConfig } from '@/components/datatable/dataTableTypes';
import type { PaginatedPrefilterTab } from '@/components/paginated-datatable/components/PaginatedDataTablePrefilterTabs.vue';
import type { PaginatedDataTableColumnConfig } from '@/components/paginated-datatable/types/paginatedDataTableTypes';
import { DocumentType } from '@/openapi';

export const columns: PaginatedDataTableColumnConfig[] = [
  { field: 'id', noWrap: true, hidden: true },
  { field: 'createdAt', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'modifiedAt', template: 'dateCell', sortable: true, hideInitial: true },
  { field: 'pointOfSales', template: 'pos', hideInitial: true },
  { field: 'customers', template: 'customers', hideInitial: true },
  { field: 'partners', template: 'partners', hideInitial: true },
  { field: 'customerGroups', template: 'customerGroupArray', hideInitial: true },
  { field: 'partnerGroups', template: 'partnerGroup', hideInitial: true },
  { field: 'name', sortable: true },
  { field: 'documentId', noWrap: true, hidden: true },
  { field: 'size', template: 'megabyte', sortable: true },
  {
    field: 'mimeType',
    template: 'mimetype',
    truncateLength: 20,
    noWrap: true,
    hideInitial: true,
  },
  { field: 'stamped', type: 'boolean', sortable: true },
  { field: 'comment', sortable: true },
  { field: 'documentTypes', template: 'simpleConnectEnumArray' },
  { field: 'signatureRequests', template: 'signatureArray', hideInitial: true },
];

export const uploadColumns: ColumnConfig[] = [
  { field: 'id', type: 'string', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'name', type: 'string' },
  { field: 'size', type: 'number' },
  { field: 'documentId', truncateLength: 8, noWrap: true, hideInitial: true },
  {
    field: 'mimeType',
    type: 'string',
    template: 'mimetype',
    truncateLength: 20,
    noWrap: true,
    hideInitial: true,
  },
  { field: 'checksumSHA256', type: 'string', truncateLength: 8, noWrap: true, hideInitial: true },
];

export const batchColumns: ColumnConfig[] = [
  { field: 'name', type: 'string' },
  { field: 'pointOfSaleId', type: 'string' },
  { field: 'pointOfSales', type: 'array', template: 'pos', hideInitial: true },
  { field: 'documentType', type: 'string' },
  { field: 'documentTypes', type: 'array', template: 'simpleConnectEnumArray', hideInitial: true },
  { field: 'ticketId', type: 'string' },
  // { field: 'ticketToAttachments', type: 'array', hideInitial: true },
  { field: 'comment', type: 'string' },
  // { field: 'ticketToDocuments', type: 'array', hideInitial: true },

  { field: 'id', type: 'string', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'version', type: 'string', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'createdAt', type: 'date', hideInitial: true },
  { field: 'modifiedAt', type: 'date', hideInitial: true },
  { field: 'customers', type: 'array', template: 'customers', hideInitial: true },
  { field: 'partners', type: 'array', template: 'partners', hideInitial: true },
  { field: 'customerGroups', type: 'array', template: 'customerGroupArray', hideInitial: true },
  { field: 'partnerGroups', type: 'array', template: 'partnerGroup', hideInitial: true },
  { field: 'documentId', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'documentVersion', type: 'string', truncateLength: 8, hideInitial: true },
  { field: 'size', type: 'number', hideInitial: true },
  {
    field: 'mimeType',
    type: 'string',
    template: 'mimetype',
    truncateLength: 20,
    noWrap: true,
    hideInitial: true,
  },
  { field: 'checksumSHA256', type: 'string', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'stamped', type: 'boolean', hideInitial: true },
];

export function generateDocumentTabs(t: (key: string) => string): PaginatedPrefilterTab[] {
  return [
    {
      title: 'labels.tabsAll',
      options: [{ title: 'labels.tabsAll', key: 'all' }],
    },
    {
      title: 'pages.documents.tabs.status',
      options: [
        {
          title: t('pages.documents.tabs.status:unclassified'),
          key: 'classifiedFalse',
          focusedColumn: 'isClassified',
        },
        {
          title: t('pages.documents.tabs.status:classified'),
          key: 'classifiedTrue',
          focusedColumn: 'isClassified',
        },
      ],
    },
    {
      title: 'pages.documents.tabs.documentType',
      options: Object.keys(DocumentType).map((key) => ({
        title: t(`enums.${key.replaceAll('_', '')}`),
        key: DocumentType[key as keyof typeof DocumentType],
        focusedColumn: 'documentType',
      })),
    },
  ];
}
